import React, { useMemo } from 'react'
import { useLeadFilters, encodeFilters } from '../LeadFiltersContext'
import ConversionRateCard from './ConversionRateCard'
import LeadConversionFunnelChart from './LeadConversionFunnelChart'
import StatsByAssigneeTable from './StatsByAssigneeTable'
import LeadInputChart from './LeadInputChart'
import StatsByProductGroupChart from './StatsByProductGroupChart'
import StatsByChannelChart from './StatsByChannelChart'
import ContactsWithRevenueTable from './ContactsWithRevenueTable'
import ContactsWithPaymentRevenueTable from './ContactsWithPaymentRevenueTable'
import RevenueByAssigneeChart from './RevenueByAssigneeChart'

const StatisticalTab: React.FC = () => {
    const { filters } = useLeadFilters()

    // Build filter payload using same base64 format as list API
    const filterPayload = useMemo(() => {
        const { q, ...encodableFilters } = filters
        return {
            q: q || undefined,
            filters: encodeFilters(encodableFilters) || undefined,
        }
    }, [filters])

    return (
        <div className="space-y-2">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                <ConversionRateCard filterPayload={filterPayload} />
                <LeadConversionFunnelChart filterPayload={filterPayload} />
            </div>
            <LeadInputChart filterPayload={filterPayload} />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                <StatsByProductGroupChart filterPayload={filterPayload} />
                <StatsByChannelChart filterPayload={filterPayload} />
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-2">
                <div className="lg:col-span-9">
                    <ContactsWithRevenueTable filterPayload={filterPayload} />
                </div>
                <div className="lg:col-span-3">
                    <RevenueByAssigneeChart filterPayload={filterPayload} />
                </div>
            </div>
            <ContactsWithPaymentRevenueTable filterPayload={filterPayload} />
            <StatsByAssigneeTable filterPayload={filterPayload} />
        </div>
    )
}

export default StatisticalTab
